export const determineWindowSize = {
    data() {
        return {
        }
    },
    methods: {
        determineWindowSize() {
            if (window.screen.width < 700) {
                this.countOfSlideInPage = 1;
            }
            else if (window.screen.width < 1100) {
                this.countOfSlideInPage = 2;
            }
            else {
                if(this.$router.currentRoute.fullPath.includes('/galereya') || this.$router.currentRoute.fullPath.includes('/sobytiya') || this.$router.currentRoute.fullPath === '/' || this.$router.currentRoute.fullPath === '/menyu') {
                    this.countOfSlideInPage = 3;
                }

                else {
                    this.countOfSlideInPage = 4;
                }
            }
        }
    },
}
